import { Box } from "@mui/material";
import { GET_LOCAL_STORAGE } from "Components/Constants/GetLocalStorage";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";


const BillHeader = ({ title, date, noDateAndTime,submittedData }) => {
const header = JSON.parse(localStorage.getItem('bizx_location'))?.stockLocationDetail?.dotHeader;
  return (
    <>
    <div className="flex-end">
      
    </div>
      <div>
        <Box sx={{ marginLeft: 1, marginRight: 1}}>
          <div
            dangerouslySetInnerHTML={{ __html: header }} />
        </Box>




      </div>



      {/* <div>
        {noDateAndTime ? null : (
        <div className="space-between mb" style={{ marginLeft: 10 , marginTop: 40}}>
          <Typography className="header-label">
            <span> Printed Date:&nbsp; {today.toDateString()}</span>
          </Typography>
          <Typography className="header-label"  style={{ marginRight: 20}}>
            <span> Printed Time: &nbsp; {today.toLocaleTimeString()}</span>
          </Typography>
        </div>
      )}
        </div> */}


    </>
  );
};

export default BillHeader;